import { HOME } from './routingConstants';

export const canShowConstantAppBar = (url) => url !== HOME;
